import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class HeaderBarStore {

}

export enum HeaderBarStoreKeys {

}
